import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'

export default ({
  base,
  dividerColor,
  textColor,
  maxWidth,
  variant
}) => {
  let jss = {
    root: {      
      ...baseStyles(base),
      '& .divider': {
        background: dividerColor,
      },
      
      '& > .divider, .with-text-container': {
        marginLeft: 'auto',
        marginRight: 'auto',
        ...parseResponsiveProperty(({value, unit}) => {
          return value ? {'maxWidth': `${value}${unit}`} : {} 
       }, maxWidth),
      },

      '& .divider-text': {
        color: textColor
      }
    }
  }

  if (variant === 'thin') {
    jss = merge(jss, {
      root: {
        '& .divider': { height: '1px' }
      }
    })
  }

  if (variant === 'thick') {
    jss = merge(jss, {
      root: {
        '& .divider': { height: '4px' }
      }
    })
  }

  return jss
}
